import React, { useState, useEffect } from "react";
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import "../styles/LoginDashboard.css";

const LoginDashboard = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [userChecked, setUserChecked] = useState(false);

  const navigate = useNavigate();
  const auth = getAuth();

  // ✅ Se já estiver logado, redireciona para o dashboard
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate("/dashboard");
      }
      setUserChecked(true);
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem("user", JSON.stringify(userCredential.user)); // ✅ Salva no localStorage
      Swal.fire({
        icon: "success",
        title: "Login bem-sucedido!",
        showConfirmButton: false,
        timer: 1500,
      });
      navigate("/dashboard");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Falha no login",
        text: "Verifique seu e-mail e senha e tente novamente.",
      });
    }
    setLoading(false);
  };

  const handlePasswordReset = async () => {
    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Digite seu e-mail",
        text: "Para redefinir a senha, digite seu e-mail no campo acima.",
      });
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      Swal.fire({
        icon: "info",
        title: "E-mail enviado!",
        text: "Verifique sua caixa de entrada para redefinir sua senha.",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao enviar e-mail",
        text: "Verifique se o e-mail está correto e tente novamente.",
      });
    }
  };

  if (!userChecked) {
    return <div className="text-center mt-5"><h2>Atualizando...</h2></div>;
  }

  return (
    <div className="login-container d-flex justify-content-center align-items-center vh-100">
      <div className="card login-box shadow-lg p-4">
        <h2 className="text-center mb-4">🔒 Login do Dashboardd</h2>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">E-mail</label>
            <input
              type="email"
              className="form-control"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Senha</label>
            <input
              type="password"
              className="form-control"
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Entrando..." : "Entrar"}
          </button>
          <button type="button" className="btn btn-link w-100 mt-2" onClick={handlePasswordReset}>
            Esqueci minha senha
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginDashboard;
